import { gql } from "@apollo/client";

export const createView = gql`
  mutation CreateView($view: View!) {
    CreateView(view: $view) {
      data
    }
  }
`;

export const createUserView = gql`
  mutation CreateUserView($userView: UserView!) {
    CreateUserView(userView: $userView) {
      data
    }
  }
`;

export const deleteUserView = gql`
  mutation DeleteUserView($viewId: String!, $service: String!) {
    DeleteUserView(viewId: $viewId, service: $service)
  }
`;

export const updateView = gql`
  mutation UpdateView($updateViewId: String, $view: View!) {
    UpdateView(id: $updateViewId, view: $view) {
      data
    }
  }
`;

export const getViews = gql`
  query getViews($service: String, $showAvailableCases: Boolean){
    Views(service: $service, showAvailableCases: $showAvailableCases){
      data
    }
  }
`;

export const getViewById = gql`
  query ViewById($id: String) {
    ViewById(id: $id) {
        data
    }
  }
`;

export const deleteViewQuery = gql`
  mutation DeleteView($id: String!) {
    DeleteView(id: $id)
  }
`;
